import classNames from 'classnames';
import { useMemo, useState } from 'react';
import './SCPInput.css';
import { formatMoneyToNumber, formatMoneyValue } from './formatterSCPInput';

export const SCPInput = (
  props: React.ComponentProps<'input'> & {
    amountField?: boolean;
    preventBrowserAddressDialog?: boolean;
    onValueChange?: (value: string) => void;
  },
) => {
  const {
    value,
    className,
    onValueChange,
    onBlur,
    amountField,
    preventBrowserAddressDialog,
    title,
    ...otherProps
  } = props;
  const [valueChanged, setValueChanged] = useState<typeof value>();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setValueChanged(e.target.value);
  };

  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement, Element>) => {
    const newValue = e.target.value;
    setValueChanged(undefined);

    if (amountField) {
      const newValueNumber = formatMoneyToNumber(newValue);
      onValueChange?.(newValueNumber.toString());
      return;
    }

    onValueChange?.(newValue);
  };

  const valueFormatted = useMemo(() => {
    if (amountField) return formatMoneyValue(value as string);

    return value ?? '';
  }, [amountField, value]);

  return (
    <input
      title={title}
      value={valueChanged ?? valueFormatted}
      className={classNames('scp-input', className)}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      //workaround - to not show "save this address" browser autocomplete dialog
      autoComplete={preventBrowserAddressDialog ? 'one-time-code' : undefined}
      {...otherProps}
    />
  );
};

export const SCPTextarea = (props: React.ComponentProps<'textarea'>) => {
  const { value, className, onChange, ...otherProps } = props;
  const [v, setV] = useState<typeof value>(value);

  return (
    <textarea
      className={classNames('scp-input scp-text-area', className)}
      value={v ?? ''}
      onChange={(e) => setV(e.target.value)}
      {...otherProps}
    />
  );
};
